import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";
import trash from './assets/trash.svg';

import styles from "./SampleCartModal.module.css";
import PopUpModal from "../PopUpModal/PopUpModal";

export default function SampleCartModal() {
    const dispatch = useDispatch();

    const sampleCartModalStatus = useSelector((state) => state.ui.sampleCartModalActive);
    const sampleCartProducts = useSelector((state) => state.visualizer.sampleCart); // Access Redux state

    const handleClose = function() {
        dispatch(uiActions.setSampleCartModalActive(false));
    };

    const handleCartProdDelete = function(product) {
        dispatch(visualizerActions.removeFromSampleCart({
            key:product.id,
        }));
    };

    const handleCartClear = function() {
        dispatch(visualizerActions.clearSampleCart());
    };

    // Prepare the list of items to display in the cart
    const sampleCartItems = Object.entries(sampleCartProducts).map(([key, product]) => (
        <div key={key}>
           
            <div className={styles.imgDiv}>
                <img src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${product.id}&type=prod&extra=(focus=500)&Size=250`}/>
            </div>
            <div>
               <p>{product.defaultRoomSceneSpecifier}</p>
            </div>
            <div>
               <p>{product.style}</p>
            </div>
            <div className={styles.imgDiv}>
               <p onClick={(e) => {
                        handleCartProdDelete(product);
                    }}> <img src={trash} alt="trash icon" height="25" width="auto"/></p>
            </div>

        </div>
    ));

    return (
        <>
            {sampleCartModalStatus && 
            <PopUpModal handleClose={handleClose}>
                  <div className={styles.container}>
                <h4>Sample Cart</h4>
                {Object.keys(sampleCartProducts).length > 0 ? (
                    <p onClick={handleCartClear}>Clear cart</p>
                ) : (
                    <p>You have not selected any products yet.</p>
                )}
                <div className={styles.cartItems}>{sampleCartItems}</div>
                <button type="button">Request Samples</button>
                </div>
            </PopUpModal>}
        </>
    );
    
    
}
